import React from 'react';

enum WikiIDs {
  id_standardcostexpirationdate = 'standardcostexpirationdate',
  id_packagingcost = 'packagingcost',
  id_formulacost = 'formulacost',
  id_testnewpricing = 'testnewpricing',
  id_totalonorderamount = 'totalonorderamount',
  id_ytdvolume = 'ytdvolume',
  id_ytdspent = 'ytdspent',
  id_priceupdatefrequency = 'priceupdatefrequency',
  id_perpalletlayer = 'perpalletlayer',
  id_brillebulkdensity = 'brillebulkdensity',
  id_actualbulkdensity = 'actualbulkdensity',
  id_formulanote = 'formulanote',
  id_containsamaferm = 'containsamaferm',
  id_mostrecentorderdate = 'mostrecentorderdate',
  id_revenuedivision = 'revenuedivision',
  id_pricemodel = 'pricemodel',
  id_pricetier = 'pricetier',
  id_vendoritemsfilter = 'vendoritemsfilter',
  id_backupvendors = 'backupvendors',
  id_preferredvendor = 'preferredvendor',
  id_componentcostcategory = 'componentcostcategory',
  id_newcostcomment = 'newcostcomment',
  id_currentlayercost = 'currentlayercost',
  id_testbulkdensity = 'testbulkdensity',
  id_receivingretainsample = 'receivingretainsample',
  id_expirationdategr6m = 'expirationdategr6m',
  id_visualmatch = 'visualmatch',
  id_checkoffoder = 'checkoffoder',
  id_inspectforeignmaterial = 'inspectforeignmaterial',
  id_testmoisture = 'testmoisture',
  id_containsmos = 'containsmos',
  id_screensize = 'screensize',
  id_baggingprogram = 'baggingprogram',
  id_printingprogram = 'printingprogram',
  id_bagsideprint = 'bagsideprint',
  id_cameraprogram = 'cameraprogram',
  id_closure = 'closure',
  id_lotnumberformat = 'lotnumberformat',
  id_palletdimensions = 'palletdimensions',
  id_manufacturingdateformat = 'manufacturingdateformat',
  id_flushbefore = 'flushbefore',
  id_flushbeforeqty = 'flushbeforeqty',
  id_flushafter = 'flushafter',
  id_flushafterqty = 'flushafterqty',
  id_pelletsize = 'pelletsize',
  id_gmofree = 'gmofree',
  id_organiccertified = 'organiccertified',
  id_avgmixingtime = 'avgmixingtime',
  id_bagsperminute = 'bagsperminute',
  id_bagsetupminutes = 'bagsetupminutes',
  id_steampercent = 'steampercent',
  id_feederpercent = 'feederpercent',
  id_pdi = 'pdi',
  id_moisturepercent = 'moisturepercent',
  id_moisturemax = 'moisturemax',
  id_testwateractivity = 'testwateractivity',
  id_testparticlesize = 'testparticlesize',
  id_testnir = 'testnir',
  id_ctlnutrienttesting = 'ctlnutrienttesting',
  id_nutrientmin = 'nutrientmin',
  id_mycotoxintesting = 'mycotoxintesting',
  id_openorders = 'openorders',
  id_maxunusedcost = 'maxunusedcost',
  id_maxopenpocost = 'maxopenpocost',
  id_hazardanalysis = 'hazardanalysis',
  id_description = 'description',
  id_sammsize = 'sammsize',
  id_sammdisplayedsize = 'sammdisplayedsize',
  id_vendorstatus = 'vendorstatus',
  id_vendorclass = 'vendorclass',
  id_showonpricelist = 'showonpricelist',
  id_pricelistpage = 'pricelistpage',
  id_lottracked = 'lottracked',
  id_minimuminventory = 'minimuminventory',
  id_maximuminventory = 'maximuminventory',
  id_howcomes = 'howcomes',
  id_currentpricingcost = 'currentpricingcost',
  id_pricehistory = 'pricehistory',
  id_defaultbatchtime = 'defaultbatchtime',
  id_reorderpointmaxtolerance = 'reorderpointmaxtolerance',
  id_batchsize = 'batchsize',
  id_currentbatchsize = 'currentbatchsize',
  id_defaultbatchsize = 'defaultbatchsize',
  id_vendoritemid = 'vendoritemid',
  id_purchasinguofm = 'purchasinguofm',
  id_fumigation = 'fumigation',
  id_pricingformulationdate = 'pricingformulationdate',
  id_manufacturingformulationdate = 'manufacturingformulationdate',
  id_bestbydateformula = 'bestbydateformula',
  id_mixingnotscheduled = 'mixingnotscheduled',
  id_avgmonthlyuse = 'avgmonthlyuse',
  id_monthsofinventory = 'monthsofinventory',
  id_typicalorderamount = 'typicalorderamount',
  id_gpproductclass = 'gpproductclass',
  id_gpproducttype = 'gpproducttype',
  id_allitempricesreportslist = 'allitempricesreportslist',
  id_gldetails = 'gldetails',
  id_onlysellablethrubo = 'onlysellablethrubo',
  id_wowgpreconcile = 'wowgpreconcile',
  id_qualitysupplierapproval = 'qualitysupplierapproval',
  id_glowners = 'glowners',
  id_glaabrands = 'glaabrands',
  id_supplychainlistexcel = 'supplychainlistexcel',
  id_mfgfilter = 'mfgfilter',
  id_pt = 'pt',
  id_perm = 'perm',
  id_trkset = 'trkset',
  id_sysal = 'sysal',
  id_amreq = 'amreq',
  id_aoreq = 'aoreq',
  id_brandpage = 'brandpage',
  id_amdry = 'amdry',
  id_frc = 'frc',
  id_custprc = 'custprc',
  id_promo = 'promo',
  id_dist = 'dist',
  id_purch = 'purch',
  id_pricingtable = 'pricingtable',
  id_eastonsch = 'eastonsch',
  id_mixingsch = 'mixingsch',
  id_eastonsdlb = 'eastonsdlb',
  id_eastonmdmx = 'eastonmdmx',
  id_eastonferm = 'eastonferm',
  id_eastonmdmxver = 'eastonmdmxver',
  id_eastonfermver = 'eastonfermver',
  id_eastonstorver = 'eastonstorver',
  id_eastonlabver = 'eastonlabver',
  id_eastonekonek = 'eastonekonek',
  id_eastonptbag = 'eastonptbag',
  id_eastonlab = 'eastonlab',
  id_eastonanalyticallab = 'eastonanalyticallab',
  id_eastonstorage = 'eastonstorage',
  id_stockyardsqly = 'stockyardsqly',
  id_eastonqly = 'eastonqly',
  id_orderfrm = 'orderfrm',
  id_splychn = 'splychn',
  id_splychndet = 'splychndet',
  id_scheduledproducitonmixing = 'scheduledproductionmixing',
  id_ptpage = 'ptpage',
  id_pmpage = 'pmpage',
  id_vendors = 'vendors',
  id_checkpricing = 'checkpricing',
  id_invchecklist = 'invchecklist',
  id_mixing = 'mixing',
  id_bagging = 'bagging',
  id_reworks = 'reworks',
  id_stockyardtestinglab = 'stockyardtestinglab',
  id_stackit = 'stackit',
  id_stackonit = 'stackonit',
  id_putintopper = 'putintopper',
  id_itemdimensions = 'itemdimensions',
  id_orderformdisplay = 'orderformdisplay',
  id_eastonchecklist = 'eastonchecklist',
  id_productionsetup = 'productionsetup',
  id_stockyardsan = 'stockyardsan',
  id_stockyardfac = 'stockyardfac',
  id_eastonsan = 'eastonsan',
  id_eastonfac = 'eastonfac',
  id_stockyardmaincheck = 'stockyardmaincheck',
  id_eastonmaincheck = 'eastonmaincheck',
  id_stockyardtrackver = 'stockyardtrackver',
  id_freight = 'freight',
  id_times = 'times',
  id_reports = 'reports',
  id_itemrequest = 'itemrequest',
  id_vendordetail = 'vendordetail',
  id_vendorrequest = 'vendorrequest',
  id_vendorrequestedprice = 'vendorrequestedprice',
  id_wiki = 'wiki',
  id_biozymebucks = 'biozymebucks',
  id_orderfields = 'orderfields',
  id_orderitem = 'orderitem',
  id_baseuofm = 'baseuofm',
  id_maprestriction = 'maprestriction',
  id_vfdrestriction = 'vfdrestriction',
  id_locrestriction = 'locrestriction',
  id_ptshowprice = 'ptshowprice',
  id_availableinventory = 'availableinventory',
  id_pickableinventory = 'pickableinventory',
  id_orderableinventory = 'orderableinventory',
  id_openpoqty = 'openpoqty',
  id_restrictorderquantity = 'restrictorderquantity',
  id_ffsamm = 'ffsamm',
  id_ffsites = 'ffsites',
  id_ffpickupvehicles = 'ffpickupvehicles',
  id_ffmaxshipping = 'ffmaxshipping',
  id_ftbasedays = 'ftbasedays',
  id_ftsammbasedays = 'ftsammbasedays',
  id_ftshopifybasedays = 'ftshopifybasedays',
  id_ftcutoff = 'ftcutoff',
  id_ftcloseddates = 'ftcloseddates',
  id_ftcloseddays = 'ftcloseddays',
  id_ftcustomerbasedays = 'ftcustomerbasedays',
  id_ftcategories = 'ftcategories',
  id_ftitems = 'ftitems',
  id_ftproducttypes = 'ftproducttypes',
  id_reqshipcalc = 'reqshipcalc',
  id_reorderpoint = 'reorderpoint',
  id_pricingweight = 'pricingweight',
  id_minpurchamt = 'minpurchamt',
  id_orderdist = 'orderdist',
  id_distributions = 'distributions',
  id_distributiondivisions = 'distributiondivisions',
  id_distributiondivisioncategories = 'distributiondivisioncategories',
  id_orderhold = 'orderhold',
  id_merchsizes = 'merchsizes',
  id_downstream = 'downstream',
  id_shopify_newshopifyorder = 'newshopifyorder',
  id_shopify_getitempricing = 'getitempricing',
  id_normalleadtime = 'normalleadtime',
  id_longleadtime = 'longleadtime',
  id_avgleadtime = 'avgleadtime',
  id_allitempricesreport = 'allitempricesreport',
  id_smallpackfulfillment = 'smallpackfulfillment',
  id_backofficebrandtoaabrand = 'backofficebrandtoaabrand',
  id_formulabuilder = 'formulabuilder',
  id_itemsneedingpurchased = 'itemsneedingpurchased',
  id_probleminventory = 'probleminventory',
  id_pricelevelhistoryreport = 'pricelevelhistoryreport',
  id_componentpricingreport = 'componentpricingreport',
  id_customerpricelistreport = 'customerpricelistreport',
  id_promotioninvoicereport = 'promotioninvoicereport',
  id_inboundreceivinglogreport = 'inboundreceivinglogreport',
  id_projectedbalancesreport = 'projectedbalancesreport',
  id_sellableitemininventoryreport = 'sellableitemininventoryreport',
  id_qaholdhistoryreport = 'qaholdhistoryreport',
  id_masterpackagingreferencereport = 'masterpackagingreferencereport',
  id_mixeditemcomponentsperbatchreport = 'mixeditemcomponentsperbatchreport',
  id_approvedsuppliersreport = 'approvedsuppliersreport',
  id_amafermlevelsreport = 'amafermlevelsreport',
  id_aobioticslevelsreport = 'aobioticslevelsreport',
  id_productshortagereport = 'productshortagereport',
  id_lotsummaryreport = 'lotsummaryreport',
  id_dryerlotchartsreport = 'dryerlotchartsreport',
  id_dryermoisturereport = 'dryermoisturereport',
  id_dryermoisturescatter2report = 'dryermoisturescatter2report',
  id_dryermoistureweeklyreport = 'dryermoistureweeklyreport',
  id_dryermoistureweeklyscatterreport = 'dryermoistureweeklyscatterreport',
  id_dryermoisturemonthlyreport = 'dryermoisturemonthlyreport',
  id_dryermoisturemonthlyscatterreport = 'dryermoisturemonthlyscatterreport',
  id_meanbagweightsreport = 'meanbagweightsreport',
  id_runsreport = 'runsreport',
  id_invoicereport = 'invoicereport',
  id_intlinvoicereport = 'intlinvoicereport',
  id_packingslipreport = 'packingslipreport',
  id_inventoryagingreport = 'inventoryagingreport',
  id_qamfgreport = 'qamfgreport',
  id_customersnosalespersonalert = 'customersnosalespersonalert',
  id_bomitemmissingpackagingpricealert = 'bomitemmissingpackagingpricealert',
  id_invalidcustomerclassalert = 'invalidcustomerclassalert',
  id_inventorynocertalert = 'inventorynocertalert',
  id_itemcomponentmissingcostalert = 'itemcomponentmissingcostalert',
  id_itemdiscontinuealert = 'itemdiscontinuealert',
  id_itemformulanoaclbulkdensityalert = 'itemformulanoaclbulkdensityalert',
  id_itempackagingmissingbomalert = 'itempackagingmissingbomalert',
  id_itemuofmmismatchalert = 'itemuofmmismatchalert',
  id_itemupcominghaalert = 'itemupcominghaalert',
  id_packaginglowquantityalert = 'packaginglowquantityalert',
  id_salespersonswithnoaccountalert = 'salespersonswithnoaccountalert',
  id_sopholdalert = 'sopholdalert',
  id_uofmmissinglbconversionalert = 'uofmmissinglbconversionalert',
  id_vendorupcommingreapprovalert = 'vendorupcommingreapprovalert',
  id_uofmschedule = 'uofmschedule',
  id_wipperbaseuofm = 'wipperbaseuofm',
}

export default WikiIDs;
